import { useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { useShipForm } from '../../../context/shipForms';
import { timesObj } from '../../../initial-values';
import { AddressDto, pickupValidationPayloadDto } from '../../../types';
import { filterTimesObj } from '../../../utils/helper';
interface Props {
  pickupPayloadForm: pickupValidationPayloadDto;
  setPickupPayloadForm: any;
  pickupPayloadValidation: any;
  setPickupPayloadValidation: any;
  isValidating: boolean;
  pickupValidateDataContext: any;
  bookPickUp: boolean;
  setBookPickUp: any;
  timezoneDataFromContext: any;
}
function PickUpFields({
  pickupPayloadForm,
  setPickupPayloadForm,
  pickupPayloadValidation,
  setPickupPayloadValidation,
  isValidating,
  pickupValidateDataContext,
  timezoneDataFromContext,
  bookPickUp,
  setBookPickUp,
}: Props) {
  const {
    getMultiLegListContext,
    getOriginFormData,
  } = useShipForm();
  const multiLegListContext = getMultiLegListContext();
  const originFormContextData: AddressDto = getOriginFormData();
  const [minDate, setMinDate] = useState<Date>(new Date());
  const [timezoneDataContext, setTimezoneDataContext] = useState<any>(
    timezoneDataFromContext
  );
  const filteredBusinessTimes = filterTimesObj(
    timesObj,
    pickupValidateDataContext && pickupValidateDataContext[0]?.min_end_time,
    pickupValidateDataContext && pickupValidateDataContext[0]?.max_end_time
  );
  const pickupStartTime = filterTimesObj(
    timesObj,
    pickupValidateDataContext && pickupValidateDataContext[0]?.min_start_time,
    pickupValidateDataContext && pickupValidateDataContext[0]?.max_start_time
  );
  const maxPickupDate = pickupValidateDataContext
    ? new Date(
        Date.now() +
          pickupValidateDataContext[0]?.max_pickup_days * 24 * 60 * 60 * 1000
      )
    : new Date(Date.now() + 14 * 24 * 60 * 60 * 1000);
  useEffect(() => {
    if (timezoneDataContext) {
      let currentDate: any = new Date().toLocaleString('en-US', {
        timeZone: timezoneDataContext?.timezone,
      });
      currentDate = new Date(currentDate);
      // Check if current time is past 2pm
      if (currentDate.getHours() >= 14) {
        // Move to the next day
        currentDate.setDate(currentDate.getDate() + 1);

        // Check if the next day is Saturday or Sunday
        if (currentDate.getDay() === 6) {
          currentDate.setDate(currentDate.getDate() + 2);
        }
      }
      if (currentDate.getDay() === 0) {
        currentDate.setDate(currentDate.getDate() + 1);
      }
      setMinDate(currentDate);
      // Update pickupPayloadForm.date
      setPickupPayloadForm({
        ...pickupPayloadForm,
        date: currentDate,
        startTime: pickupValidateDataContext[0]?.min_start_time,
        endTime: pickupValidateDataContext[0]?.min_end_time,
      });
    }
  }, [timezoneDataContext]);

  let firstNewLeg = {
    origin: {
      address: '',
      city: '',
      country: '',
      province: '',
      postal_code: '',
      has_shipping_bays: null,
    },
  };
  if (multiLegListContext?.length > 0) {
    firstNewLeg = multiLegListContext[0];
  }

  return (
    <div className='ubbe-card h-100'>
      <div className='ubbe-card-header'>
        <h5 className='ps-3 mb-0 GlobalBoxHead'>Optional Pickup</h5>
      </div>
      <div className='card-body pt-3 p-4'>
        <div className='row'>
          <div className='col-sm-12 col-md-12'>
            <p className='global-text-16'>
              Tell us when you'd like your shipment to be picked up.
            </p>
            <h6 className='boldglobaltext pt-2'>Pickup Address</h6>
            <div
              className='global-text-16'
              id='pickup_address'
            >
              <>
                {firstNewLeg?.origin?.address || 'N/A'}
                {''}
                {firstNewLeg?.origin?.city &&
                  `, ${firstNewLeg?.origin?.city}`}
                {firstNewLeg?.origin?.province &&
                  `, ${firstNewLeg?.origin?.province}`}
                {firstNewLeg?.origin?.country &&
                  `, ${firstNewLeg?.origin?.country}`}
                {firstNewLeg?.origin?.postal_code &&
                  ` ${firstNewLeg?.origin?.postal_code}`}
              </>
            </div>
            <h6 className='boldglobaltext mt-3'>Timezone</h6>
            <div
              className='global-text-16'
              id='timezone_details'
            >
              {timezoneDataContext?.timezone_name ? (
                <>
                  {timezoneDataContext?.timezone_name}

                  <span id='timezone'>
                    {timezoneDataContext?.timezone
                      ? timezoneDataContext?.timezone
                      : 'N/A'}
                  </span>
                  <br />
                  <span className='field-bold'>
                    {timezoneDataContext?.timezone_time}
                  </span>
                </>
              ) : (
                'N/A'
              )}
            </div>
          </div>
          <div className='col-sm-12 col-md-12 my-auto'>
            <div className='mb-3'>
              <div className='form-check mt-3'>
                <input
                  className='form-check-input'
                  type='checkbox'
                  checked={bookPickUp}
                  id='pickup_is_pickup'
                  onChange={(e) => {
                    setBookPickUp(e.target.checked);
                  }}
                />
                <label
                  className='global-text-16'
                  htmlFor='pickup_is_pickup'
                >
                  Do you want to book a pickup?
                </label>
              </div>
            </div>
            {bookPickUp ? (
              <div id='pickup_fields_section'>
                <div className='mb-3'>
                  <label
                    className='boldglobaltext'
                    htmlFor='pickup_date'
                  >
                    Pickup Date <span className='text-danger fw-bold'>*</span>
                  </label>
                  <DatePicker
                    id={'pickup_date'}
                    selected={pickupPayloadForm.date}
                    minDate={minDate}
                    maxDate={maxPickupDate}
                    filterDate={(date) => {
                      return date.getDay() !== 0 && date.getDay() !== 6;
                    }}
                    dateFormat='yyyy-MM-dd'
                    className={'form-control ubbe-input'}
                    onChange={(date: any) => {
                      setPickupPayloadForm({
                        ...pickupPayloadForm,
                        date: date,
                      });
                    }}
                    showIcon={true}
                    calendarIconClassname='calendarIcon'
                  />
                </div>

                <div className='mb-3'>
                  <label
                    className='boldglobaltext'
                    htmlFor='time'
                  >
                    Pickup Time <span className='text-danger fw-bold'>*</span>
                  </label>
                  <select
                    id='time'
                    className='form-select ubbe-input w-100'
                    data-size='6'
                    value={pickupPayloadForm.startTime}
                    onChange={(e) => {
                      setPickupPayloadForm({
                        ...pickupPayloadForm,
                        startTime: e.target.value,
                      });
                      setPickupPayloadValidation({
                        ...pickupPayloadValidation,
                        startTime: e.target.value !== '',
                      });
                    }}
                  >
                    <option value=''>Select a time</option>
                    {pickupStartTime.map((time: string, index) => (
                      <option
                        key={index}
                        value={time}
                      >
                        {time}
                      </option>
                    ))}
                  </select>
                  {isValidating && pickupPayloadForm.startTime === '' && (
                    <div
                      className='invalid-feedback'
                      id='time_error'
                    >
                      Please provide a valid Time.
                    </div>
                  )}
                </div>

                <div className='mb-3'>
                  <label
                    className='boldglobaltext my-auto '
                    htmlFor='close_time'
                  >
                    Business Close Time
                    <span
                      className='text-danger fw-bold'
                      style={{ marginLeft: '2px' }}
                    >
                      *
                    </span>
                  </label>
                  <select
                    id='close_time'
                    className='form-select ubbe-input w-100'
                    data-size='6'
                    value={pickupPayloadForm?.endTime}
                    onChange={(e) => {
                      setPickupPayloadForm({
                        ...pickupPayloadForm,
                        endTime: e.target.value,
                      });
                      setPickupPayloadValidation({
                        ...pickupPayloadValidation,
                        endTime: e.target.value !== '',
                      });
                    }}
                  >
                    <option value=''>Select a time</option>
                    {filteredBusinessTimes.map((time: string, index) => (
                      <option
                        key={index}
                        value={time}
                      >
                        {time}
                      </option>
                    ))}
                  </select>
                  {isValidating && pickupPayloadForm.endTime === '' && (
                    <div
                      className='invalid-feedback'
                      id='time_error'
                    >
                      Please provide a valid Close Time.
                    </div>
                  )}
                </div>
              </div>
            ) : (
              <div id='no_pickup_section'>
                <p className='global-text-16'>
                  A Pickup will not be booked, you will need to drop off the
                  shipment at the nearest location.
                  <br />
                  <br />
                  If you change your mind, a pickup can be booked from the
                  shipment lookup page.
                </p>
              </div>
            )}

            <p
              className='text-danger'
              id='pickup_errors'
            ></p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PickUpFields;
